import * as React from "react";

export const QuenteIconRed = (props: any) => (
  <svg
    width={22}
    height={23}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m5.76 4.84-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41ZM0 10.5h3v2H0v-2ZM10 .55h2V3.5h-2V.55Zm8.04 2.495 1.408 1.407-1.79 1.79-1.407-1.408 1.789-1.789Zm-1.8 15.115 1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4ZM19 10.5h3v2h-3v-2Zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6Zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4Zm-1 4h2v2.95h-2V19.5Zm-7.45-.96 1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8Z"
      fill="#F43636"
    />
  </svg>
);
